/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter as Router } from "react-router-dom";
import { SetGlobalStyle } from "@nordcloud/gnui";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/global.css";
import { CustomerConfigProvider } from "~/context/CustomerConfig";
import { NotificationProvider } from "~/context/Notifications";
import { GNUIThemeProvider } from "~/hooks/useGNUITheme";
import { ApolloProvider } from "~/services/apollo";
import { Auth0ProviderWithHistory, AuthWall } from "~/services/auth";
import { Maintenance } from "~/views/Maintenance";
import { App } from "./App";
import { ErrorFallback } from "./components/Error/CriticalFallback";
import { CustomersProvider } from "./services/customers";
import "./setupDayjs";

/* eslint-disable react/jsx-max-depth */

ReactDOM.render(
  <StrictMode>
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <ErrorFallback
          error={error}
          resetErrorBoundary={resetErrorBoundary}
          message="Go to homepage"
        />
      )}
      onReset={() => (window.location.href = "/")}
    >
      <Router>
        <Auth0ProviderWithHistory>
          <AuthWall>
            <SetGlobalStyle customScrollbars />
            <Maintenance>
              <ApolloProvider>
                <CustomersProvider>
                  <CustomerConfigProvider>
                    <NotificationProvider>
                      <GNUIThemeProvider>
                        <App />
                      </GNUIThemeProvider>
                    </NotificationProvider>
                  </CustomerConfigProvider>
                </CustomersProvider>
              </ApolloProvider>
            </Maintenance>
          </AuthWall>
        </Auth0ProviderWithHistory>
      </Router>
    </ErrorBoundary>
  </StrictMode>,
  document.getElementById("root")
);
